import compose from 'react-hooks-compose'

import { useLogic } from './useLogic'
import { Presenter } from './presenter'

export const InputMap = compose(props => ({
	useLogic: () => useLogic(props),
}))(Presenter)
